const ENV_DEVELOPMENT = 'development'

interface ConfigType {
  ENVIRONMENT: string
  PROXIMA_BACK_END_V2_BASE_API_URL: string
  KYC_TIER_3_PLUGIN_URL: string
  IS_KYC_ACTIVE: boolean
}

const CONFIG: ConfigType = {
  ENVIRONMENT: '',
  PROXIMA_BACK_END_V2_BASE_API_URL: '',
  KYC_TIER_3_PLUGIN_URL: '',
  IS_KYC_ACTIVE: true
}

const env = import.meta.env

CONFIG.ENVIRONMENT = env.VITE_ENVIRONMENT ?? ENV_DEVELOPMENT
CONFIG.PROXIMA_BACK_END_V2_BASE_API_URL = env.VITE_PROXIMA_BACK_END_V2_BASE_API_URL ?? ''
CONFIG.KYC_TIER_3_PLUGIN_URL = env.VITE_KYC_TIER_3_PLUGIN_URL ?? ''
CONFIG.IS_KYC_ACTIVE = env.VITE_IS_KYC_ACTIVE === 'true'

export default CONFIG
